export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";
export const FETCH_REMOVEFROMCART_REQUEST = "FETCH_REMOVEFROMCART_REQUEST";
export const FETCH_REMOVEFROMCART_SUCCESS = "FETCH_REMOVEFROMCART_SUCCESS";
export const FETCH_REMOVEFROMCART_FAILURE = "FETCH_REMOVEFROMCART_FAILURE";
export const FETCH_ADDTOCART_REQUEST = "FETCH_ADDTOCART_REQUEST";
export const FETCH_ADDTOCART_SUCCESS = "FETCH_ADDTOCART_SUCCESS";
export const FETCH_ADDTOCART_FAILURE = "FETCH_ADDTOCART_FAILURE";
export const FETCH_MODIFYCART_REQUEST = "FETCH_MODIFYCART_REQUEST";
export const FETCH_MODIFYCART_SUCCESS = "FETCH_MODIFYCART_SUCCESS";
export const FETCH_MODIFYCART_FAILURE = "FETCH_MODIFYCART_FAILURE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const GO_TO_CHECKOUT = "GO_TO_CHECKOUT";
